import { render, staticRenderFns } from "./Korpa.vue?vue&type=template&id=3b02bbca&"
import script from "./Korpa.vue?vue&type=script&lang=js&"
export * from "./Korpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports